import React, { useEffect, useState } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import useMediaQuery from '@mui/material/useMediaQuery';
import IGamingOfferImage1 from '../../../assets/images/home/IGamingOfferImage1.png';
import IGamingOfferImage2 from '../../../assets/images/home/IGamingOfferImage2.png';
import IGamingOfferImage3 from '../../../assets/images/home/IGamingOfferImage3.png';
import IGamingOfferImage4 from '../../../assets/images/home/IGamingOfferImage4.png';
import ProvidersSection from '../../../components/Shared/ProvidersSection';

import { useTranslation } from 'react-i18next';
import StyledIGamingOffer from './styles';

const IGamingOffer = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [isScrollSection, setIsScrollSection] = useState(false);
  const [dividerWidth, setDividerWidth] = useState(0); // Initial width (in %)
  const [background, setBackground] = useState('rgb(0, 0, 0)');

  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        const position = window.scrollY;

        let height = 4500;
        if (isMobile) {
          height = 4800;
        }

        // console.log(position);
        if (position >= height) {
          setIsScrollSection(true);
          // Map scroll percentage to a width range (10% to 100%)
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = ((position - height) / documentHeight) * 2000;
          const newWidth = Math.min(100, Math.max(10, scrollPercent + 10)); // Adjust range as needed
          setDividerWidth(newWidth);
          setBackground(
            `rgb(${Math.round(newWidth * 2.328) + 22}, ${Math.round(newWidth * 2.328) + 22}, ${Math.round(newWidth * 2.328) + 22})`,
          );

          // console.log(documentHeight);
          // console.log(scrollPercent);
          // console.log(newWidth);
          // console.log(scrollYProgress);
        } else {
          setIsScrollSection(false);
          setDividerWidth(0);
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = ((position - height) / documentHeight) * 2000;
          const newWidth = Math.min(100, Math.max(10, scrollPercent + 10)); // Adjust range as needed
          // setBackground('rgb(155, 155, 155)');

          setBackground(
            `rgb(${Math.round(scrollPercent) + 0}, ${Math.round(scrollPercent) + 0}, ${Math.round(scrollPercent) + 0})`,
          );

          // console.log(documentHeight);
          // console.log(scrollPercent);
          // console.log(newWidth);
          // console.log(scrollYProgress);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isScrollSection]);

  const label1 = t('igamingoffer-label-desktop-one');
  const label2 = t('igamingoffer-label-desktop-two');
  const label2Mobile = t('igamingoffer-label-desktop-two');
  const iGamingOffers = [
    {
      id: 1,
      title: t('igamingoffer-title-one'),
      content: t('igamingoffer-content-one'),
      image: IGamingOfferImage1,
    },
    {
      id: 2,
      title: t('igamingoffer-title-two'),
      content: t('igamingoffer-content-two'),
      image: IGamingOfferImage2,
    },
    {
      id: 3,
      title: t('igamingoffer-title-three'),
      content: t('igamingoffer-content-three'),
      image: IGamingOfferImage3,
    },
    {
      id: 4,
      title: t('igamingoffer-title-four'),
      content: t('igamingoffer-content-four'),
      image: IGamingOfferImage4,
    },
  ];
  return (
    <StyledIGamingOffer>
      {/* <Box className="homeBg">
        <video width="100%" autoPlay loop muted playsInline className="videoElement">
          <source src={BgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box> */}
      {/* <Wave
        fill="#000"
        paused={false}
        style={{
          display: 'flex',
          position: 'absolute',
          marginTop: '-40px',
        }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
        className="wave"
      /> */}
      <Box
        className="homeContent"
        style={{ backgroundColor: `${background}` }}
        sx={
          {
            // background: isScrollSection ? 'linear-gradient(180deg, #000000 48.02%, #FFFFFF 100%)' : '#000000',
            // background: `linear-gradient(180deg, rgb(0, 0, 0) 48.02%, ${background} 100%)`,
            // background: 'linear-gradient(180deg, rgb(0, 0, 0) 48.02%, rgb(255, 255, 255) 100%)',
          }
        }
      >
        <div className="card">
          {/* <Box className="iconBrandLogo" sx={{ height: '170px' }}>
            <IconBrandLogo />
          </Box> */}
          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: '48px',
                fontWeight: '800',
                mb: 6,
                mt: 6,
                lineHeight: '57.28px',
                [theme.breakpoints.down('lg')]: {
                  // position: 'absolute',
                  fontSize: '40px',
                  lineHeight: '47.73px',
                  padding: '0 20px',
                  mb: 3,
                  mt: 1,
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              >
                {label1}
              </motion.div>
            </Typography>
            <Box sx={{
              padding: '0 30px',
              [theme.breakpoints.down('lg')]: {
                padding: '0 10px',
              },
            }}>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                  fontSize: '20px',
                  lineHeight: '23.87px',
                  mb: 2,
                  [theme.breakpoints.down('lg')]: {
                    display: 'none',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 60,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  {parse(label2)}
                </motion.div>
              </Typography>
              <motion.div
                initial={{
                  opacity: 0,
                  y: 60,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    lineHeight: 1.8,
                    wordWrap: 'break-word',
                    fontWeight: 700,
                    fontSize: '20px',
                    lineHeight: '26px',
                    mb: 10,
                    display: 'none',
                    [theme.breakpoints.down('lg')]: {
                      display: 'flex',
                      fontSize: '18px',
                      fontWeight: 500,
                      lineHeight: '23.4px',
                      mb: 'unset'
                    },
                  }}
                  className='label2'
                >
                  {parse(label2Mobile)}
                </Typography>
              </motion.div>
            </Box>
            <Box
              display={'grid'}
              justifyContent={'center'}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                [theme.breakpoints.down('lg')]: {
                  display: 'none',
                },
              }}
            >
              {iGamingOffers.map((item, index) => (
                <Box
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    mt: 5,
                    [theme.breakpoints.down('lg')]: {
                      boxShadow: '0px 5px 5px 0px #00000040',
                    },
                  }}
                  display={'flex'}
                  key={item.id}
                >
                  <Box
                    sx={{
                      backgroundColor: '#ffffff',
                      textAlign: 'left',
                      paddingLeft: 5,
                      paddingRight: 5,
                      width: '850px',
                      height: localStorage.getItem('i18nextLng') === 'en-US' ? '450px' : '380px',
                      maxWidth: '850px',
                      maxHeight: localStorage.getItem('i18nextLng') === 'en-US' ? '450px' : '380px',
                      [theme.breakpoints.down('lg')]: {
                        paddingLeft: 0,
                        paddingRight: 0,
                        maxWidth: '850px',
                        // width: '400px',
                        width: '100%',
                      },
                    }}
                  >
                    <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' } }}>
                      <img
                        src={item.image}
                        style={{
                          // width: '400px',
                          height: '254px',
                          maxWidth: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 8,
                        mb: 3,
                        lineHeight: '47.73px',
                        wordWrap: 'break-word',
                        fontWeight: 800,
                        fontSize: '40px',
                        color: '#000000',
                        [theme.breakpoints.down('lg')]: {
                          mt: 1,
                          padding: '0 20px',
                          fontSize: '30px',
                          lineHeight: '35.8px',
                        },
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        height: '154px',
                        [theme.breakpoints.down('lg')]: {
                          height: 'auto',
                        },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 4,
                          lineHeight: '21.48px',
                          wordWrap: 'break-word',
                          fontWeight: 600,
                          fontSize: '18px',
                          color: '#6C6964',
                          [theme.breakpoints.down('lg')]: {
                            padding: '0 20px',
                            fontSize: '18px',
                            lineHeight: '21.48px',
                          },
                        }}
                      >
                        {parse(item.content)}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        // mb: 8,
                        mt: localStorage.getItem('i18nextLng') === 'en-US' ? 7 : 4,
                        lineHeight: 1,
                        wordWrap: 'break-word',
                        fontWeight: 400,
                        fontSize: '17.6px',
                        color: '#DC0B35',
                        [theme.breakpoints.down('lg')]: {
                          mb: 4,
                          padding: '0 20px',
                          fontSize: '18px',
                          lineHeight: '21.48px',
                        },
                      }}
                    >
                      {t('igamingoffer-label-three')}
                    </Typography>
                  </Box>
                  <Box sx={{ display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' } }}>
                    <img
                      src={item.image}
                      style={{
                        width: '532px',
                        height: '321.56px',
                        maxWidth: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
            <Box
              display={'none'}
              justifyContent={'center'}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                [theme.breakpoints.down('lg')]: {
                  display: 'grid',
                  padding: '0 35px',
                },
              }}
            >
              {iGamingOffers.map((item, index) => (
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 60,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: index * 0.3,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <Box
                    sx={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      mt: 5,
                      [theme.breakpoints.down('lg')]: {
                        boxShadow: '0px 5px 5px 0px #00000040',
                      },
                    }}
                    display={'flex'}
                    key={item.id}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#ffffff',
                        textAlign: 'left',
                        paddingLeft: 5,
                        paddingRight: 5,
                        width: '628px',
                        // height: '321.56px',
                        maxWidth: '628px',
                        maxHeight: '100%',
                        [theme.breakpoints.down('lg')]: {
                          paddingLeft: 0,
                          paddingRight: 0,
                          maxWidth: '628px',
                          // width: '400px',
                          width: '100%',
                        },
                      }}
                    >
                      <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' } }}>
                        <img
                          src={item.image}
                          style={{
                            // width: '400px',
                            height: '254px',
                            maxWidth: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            width: '100%',
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          mt: 8,
                          mb: 3,
                          lineHeight: 1,
                          wordWrap: 'break-word',
                          fontWeight: 800,
                          fontSize: '40px',
                          color: '#000000',
                          [theme.breakpoints.down('lg')]: {
                            mt: 4,
                            padding: '0 20px',
                            fontSize: '24px',
                            lineHeight: '28.64px',
                          },
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Box
                        sx={{
                          height: '154px',
                          [theme.breakpoints.down('lg')]: {
                            height: 'auto',
                          },
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            mb: 4,
                            lineHeight: '25.6px',
                            wordWrap: 'break-word',
                            fontWeight: 600,
                            fontSize: '17.46px',
                            color: '#6C6964',
                            [theme.breakpoints.down('lg')]: {
                              padding: '0 20px',
                              fontSize: '16px',
                              lineHeight: '22px',
                              fontWeight: 500,
                              mb: 2,
                            },
                          }}
                        >
                          {parse(item.content)}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 8,
                          lineHeight: 1,
                          wordWrap: 'break-word',
                          fontWeight: 400,
                          fontSize: '17.6px',
                          color: '#DC0B35',
                          [theme.breakpoints.down('lg')]: {
                            mb: 4,
                            padding: '0 20px',
                            fontSize: '14px',
                            lineHeight: '16.71px',
                            fontWeight: 700,
                          },
                        }}
                      >
                        {t('igamingoffer-label-three')}
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' } }}>
                      <img
                        src={item.image}
                        style={{
                          width: '532px',
                          height: '321.56px',
                          maxWidth: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </Box>
                  </Box>
                </motion.div>
              ))}
            </Box>
          </Box>
        </div>

        <Box
          sx={{
            display: 'flex',
            marginTop: '150px',
            marginBottom: '150px',
            justifyContent: 'center',
            padding: '0 30px',
            width: '100%',
            [theme.breakpoints.down('lg')]: {
              marginTop: '50px',
              marginBottom: '50px',
              padding: '0 10px'
            },
          }}
        >
          <motion.div
            style={{
              height: '8px', // Divider thickness
              background: 'linear-gradient(90deg, #00FF00 0%, #01B762 50.44%, #017780 100%)',
              marginTop: '20px',
              borderRadius: '100px',
            }}
            animate={{ width: `${dividerWidth}%` }} // Animate width change
            transition={{ duration: 0.5, ease: 'easeOut' }} // Smooth transition
          />
        </Box>

        <ProvidersSection padding={'unset'} backgroundColor={'unset'} />

        {/* <Container maxWidth="lg">
          <motion.div
            className="card"
            initial={{
              opacity: 0,
              y: 290,
            }}
            whileInView={{
              opacity: 1,
              y: 0, // Slide in to its original position
              transition: {
                duration: 2, // Animation duration
              },
            }}
            // viewport={{ once: true }}
          >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              <Box className="bannerText" mt={2} mx={8}>
                {bannerText}
              </Box>
              <Box mt={5}>
                <Button hasEndIcon IconEnd={ArrowForwardIosIcon} text="Get Started" color={COLOR.DEFAULT} />
              </Box>
            </Box>
          </motion.div>
        </Container> */}
      </Box>
      {/* <Box
        sx={{
          display: 'flex',
          // marginTop: '150px',
          justifyContent: 'center',
          padding: '75px 60px 0px 60px',
          width: '100%',
          backgroundColor: '#fff'
        }}
      >
        <motion.div
          style={{
            height: '8px', // Divider thickness
            background: 'linear-gradient(90deg, #00FF00 0%, #01B762 50.44%, #017780 100%)',
            marginTop: '20px',
            borderRadius: '100px',
          }}
          animate={{ width: `${dividerWidth}%` }} // Animate width change
          transition={{ duration: 0.5, ease: 'easeOut' }} // Smooth transition
        />
      </Box> */}
    </StyledIGamingOffer>
  );
};

export default IGamingOffer;
